// videoParam can be either an ID or a Slug
export const getVideoUrl = videoParam => `/api/v1/videos/${videoParam}`

export const getRandomVideosUrl = ({ page, limit }) =>
  `/api/v1/videos?page=${page.toString()}&limit=${limit.toString()}`

export const getVideoCategoryUrl = categoryId =>
  `/api/v1/video_categories/${categoryId}`

export const getVideoGenreUrl = genreId => `/api/v1/video_genres/${genreId}`

export const getVideoGenresUrl = '/api/v1/video_genres'
